import { SIZES } from "@frontend/styles/constants";

export const DIALOG_SIZES = [...SIZES, "xl"] as const;

export const DIALOG_PLACEMENTS = ["center", "top"] as const;

// The gap a fullscreen dialog keeps to the viewport. Same inset as the
// expanded component preview, which is the closest thing to this in the app.
// A Window keeps half of it when maximised, but it is draggable to the edge.
export const DIALOG_FULLSCREEN_INSET = "1.5rem";

export const DIALOG_TAG_NAME = "dialog" as const;

export const DIALOG_FOOTER_TAG_NAME = "dialog-footer" as const;
